// extracted by mini-css-extract-plugin
export default {"root":"storage-page_root__KXI43","groupSelector":"storage-page_groupSelector__HOqTR"};